<span class="ap-badge">
    <ng-content></ng-content>
</span>
